import { useEffect, useState } from 'react';

import { getClassName } from '../input-class';
import { TextAreaProps } from './text-area-input.component';

interface ViewProps {
    valid: boolean;
    touched: boolean;
    inputClass: string;
    changeTouched: React.Dispatch<React.SetStateAction<boolean>>;
    isValid: () => boolean;
}

const useTextAreaInput = (props: TextAreaProps): ViewProps => {
    const [touched, changeTouched] = useState<boolean>(false);
    const [valid, changeValid] = useState<boolean>(false);

    const isValid = (): boolean => {
        let check = true;
        if (check === true && props.required === true && (props.value === '' || props.value === undefined)) check = false;
        if (props.valid !== undefined && check === true) check = props.valid;
        changeValid(check);
        return check;
    };

    useEffect(() => {
        if (props.isValidCallback) {
            props.isValidCallback(isValid());
        } else isValid();
    }, [props.value, props.valid]);

    useEffect(() => {
        if (props.submitted) {
            !touched && changeTouched(true);
        }
    }, [props.submitted]);

    return {
        changeTouched,
        isValid,
        touched,
        valid,
        inputClass: props.useConditionedStyling === false ? 'form-control' : getClassName(touched, valid, props.value)
    };
};

export default useTextAreaInput;
